export default "__VITE_ASSET__DJV59Yo1__"